export default {
  metaTitle: "USFans Spreadsheet 2026: Kompletne znaleziska i poradnik zakupowy",
  metaDescription:
    "Odkryj USFans Spreadsheet — uporządkowane znaleziska, nawigacja po kategoriach, poradniki zakupowe, wskazówki QC i informacje o wysyłce. Niezależne i aktualne.",
  heroEyebrow: "CENTRUM ZASOBÓW USFANS SPREADSHEET",
  heroH1: "USFans Spreadsheet — odkrywaj znaleziska, porównuj opcje i kupuj mądrzej",
  heroSub:
    "Poznaj najnowsze zasoby USFans Spreadsheet, przydatne znaleziska, poradniki zakupowe, wskazówki QC, informacje o wysyłce, recenzje i porady dotyczące bezpieczeństwa — wszystko w jednym miejscu.",
  heroCta1: "USFans Spreadsheet",
  heroCta2: "Kup teraz",
  heroTrust: "Niezależne źródło · Aktualne poradniki · Praktyczne informacje zakupowe",
  heroBadge: "Sprawdzony punkt startowy dla znalezisk USFans",
  categoriesH2: "Przeglądaj kategorie produktów",
  categoriesSub:
    "Przejdź bezpośrednio do potrzebnej sekcji na głównej stronie. Wybierz kategorię poniżej lub użyj listy rozwijanej powyżej.",
  categoriesGridH2: "Kupuj według kategorii",
  categoriesGridSub: "Każda kategoria prowadzi bezpośrednio do pasujących produktów USFans na głównej stronie.",
  viewCategory: "Zobacz",
  valuePropsH2: "Wszystko, co musisz wiedzieć o USFans",
  valuePropsSub: "Jedno centrum dla tematów, o które kupujący pytają najczęściej — w prostym języku.",
  vp1Title: "USFans Spreadsheet",
  vp1Desc: "Odkrywaj przydatne znaleziska i uporządkowane zasoby produktowe w jednym miejscu.",
  vp1Cta: "Przeglądaj arkusz",
  vp2Title: "Recenzje USFans",
  vp2Desc: "Poznaj platformę, funkcje, potencjalne ryzyka i ważne uwagi.",
  vp2Cta: "Przeczytaj recenzję USFans",
  vp3Title: "Wysyłka",
  vp3Desc: "Poznaj metody wysyłki, szacowane koszty i kwestie śledzenia.",
  vp3Cta: "Zobacz poradnik o wysyłce",
  vp4Title: "QC",
  vp4Desc: "Dowiedz się, co sprawdzić przed zatwierdzeniem produktów i złożeniem zamówienia.",
  vp4Cta: "Poznaj QC",
  vp5Title: "Bezpieczeństwo",
  vp5Desc: "Poznaj praktyczne sposoby ograniczania typowych ryzyk zakupowych.",
  vp5Cta: "Odwiedź centrum bezpieczeństwa",
  vp6Title: "Magazyn",
  vp6Desc: "Zrozum, jak działa przechowywanie w magazynie i przetwarzanie zamówień.",
  vp6Cta: "Przeczytaj poradnik o magazynie",
  seoH2: "Dlaczego warto korzystać z USFans Spreadsheet?",
  seoP1:
    "USFans Spreadsheet przenosi odkrywanie produktów w jedno miejsce. Zamiast przeskakiwać między rozproszonymi linkami i nieaktualnymi stronami, możesz przeglądać uporządkowane kategorie, porównywać podobne znaleziska i przechodzić bezpośrednio na główną stronę, gdy jesteś gotowy do zakupu. To oszczędza czas i ogranicza zgadywanie podczas zakupów online.",
  seoP2:
    "Dbamy o to, aby to centrum było niezależne i łatwe w użyciu. Znajdziesz tu praktyczne zasoby o kategoriach, kontroli jakości, wysyłce i bezpieczeństwie — napisane prostym językiem i regularnie aktualizowane. Niezależnie od tego, czy szukasz butów, bluz, toreb czy akcesoriów, arkusz daje Ci jasny punkt wyjścia.",
  seoList1: "Uporządkowane kategorie dla szybszego przeglądania",
  seoList2: "Proste wskazówki zakupowe",
  seoList3: "Podstawy QC, wysyłki i bezpieczeństwa",
  seoList4: "Regularnie aktualizowane zasoby",
  seoReadMore: "Przeczytaj pełny poradnik",
  seoCardTitle: "USFans Spreadsheet 2026: Kompletny poradnik",
  seoCardDesc:
    "Czym jest arkusz, jak działa, główne kategorie i jak kupować z większą pewnością — w jednym szczegółowym poradniku.",
  faqH2: "Najczęściej zadawane pytania",
  faq1Q: "Czym jest USFans Spreadsheet?",
  faq1A:
    "To uporządkowane źródło, które grupuje znaleziska USFans według kategorii, dzięki czemu możesz przeglądać i porównywać produkty w jednym miejscu.",
  faq2Q: "Czy korzystanie z USFans Spreadsheet jest darmowe?",
  faq2A:
    "Tak — przeglądanie zasobu jest darmowe. Płacisz tylko wtedy, gdy zdecydujesz się kupić przez główną stronę.",
  faq3Q: "Jak dostać się do produktów?",
  faq3A:
    "Wybierz kategorię z listy rozwijanej lub z kart kategorii, a zostaniesz przeniesiony do odpowiedniej sekcji na głównej stronie.",
  finalCtaH2: "Gotowy na przeglądanie USFans Spreadsheet?",
  finalCtaSub: "Przeglądaj uporządkowane znaleziska, porównuj kategorie i kupuj mądrzej — w jednym miejscu.",
  finalCtaPrimary: "Przeglądaj USFans Spreadsheet",
  finalCtaSecondary: "Odwiedź główną stronę",
  pillarH2: "Artykuły filarowe i poradniki",
  pillarSub: "Nasze najczęściej czytane zasoby USFans — recenzje, wysyłka, QC, bezpieczeństwo i porady zakupowe w jednym miejscu.",
  pillarRead: "Czytaj poradnik",
  p1Title: "Recenzja USFans 2026",
  p1Desc: "Czy USFans jest legalne i bezpieczne? Proste wyjaśnienie, jak działa i co sprawdzić.",
  p2Title: "Przewodnik po kosztach wysyłki USFans",
  p2Desc: "Co wpływa na cenę wysyłki i jak porównać opcje przed zamówieniem.",
  p3Title: "Poradnik o kuponach USFans",
  p3Desc: "Jak działają kupony i gdzie bezpiecznie zweryfikować promocje.",
  p4Title: "Przewodnik po kodach rabatowych USFans",
  p4Desc: "Jak znaleźć i sprawdzić aktualne kody rabatowe przed zakupem.",
  p5Title: "Przewodnik po magazynie USFans",
  p5Desc: "Jak działa przechowywanie w magazynie, QC i przetwarzanie zamówień.",
  p6Title: "Czy USFans jest legalne?",
  p6Desc: "Zrównoważone spojrzenie na zaufanie, ryzyka i ochronę kupujących.",
  p7Title: "Poradnik QC USFans",
  p7Desc: "Co sprawdzić przed zatwierdzeniem produktów i złożeniem zamówienia.",
  p8Title: "Poradnik zakupowy USFans",
  p8Desc: "Krok po kroku do zamawiania z większą pewnością.",
  p9Title: "Centrum bezpieczeństwa USFans",
  p9Desc: "Praktyczne sposoby ograniczania najczęstszych ryzyk zakupowych.",
  p10Title: "Śledzenie i wysyłka USFans",
  p10Desc: "Poznaj podstawy śledzenia i wysyłki dla swoich zamówień.",
};